// Translations for Misk Cargo — Arabic, English, Turkish
export const translations = {
  ar: {
    dir: "rtl",
    locale: "ar",
    brand: "مسك كارجو",
    brandEn: "MISK CARGO",
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      services: "خدماتنا",
      contact: "تواصل معنا",
      getQuote: "احصل على تسعيرة",
    },
    hero: {
      eyebrow: "حلول لوجستية دولية",
      title1: "مسك كارجو",
      title2: "طريقك الآمن للتجارة والشحن",
      subtitle:
        "شحن موثوق من تركيا والصين إلى سوريا، للتجار والشركات والأفراد.",
      ctaQuote: "اطلب تسعيرة",
      ctaServices: "استكشف خدماتنا",
      statShipments: "شحنة ناجحة",
      statRoutes: "مسارات نشطة",
      statClients: "عميل موثوق",
      statYears: "سنوات خبرة",
      trustSafe: "آمن وموثوق",
      trustFast: "نقل سريع",
      trustCountries: "تركيا · الصين · سوريا",
    },
    widget: {
      trackTab: "تتبع الشحنة",
      calcTab: "حاسبة الشحن",
      trackLabel: "رقم البوليصة",
      trackPlaceholder: "مثال: MK-2025-00123",
      trackBtn: "تتبع الآن",
      fromLabel: "بلد المنشأ",
      toLabel: "الوجهة",
      weightLabel: "الوزن (كغ)",
      weightPlaceholder: "مثلاً: 25",
      modeLabel: "نوع الشحن",
      modeAir: "جوي",
      modeSea: "بحري",
      modeLand: "بري",
      calcBtn: "احسب السعر",
      resultTitle: "التقدير المبدئي",
      resultNote: "السعر تقديري ويخضع لطبيعة البضاعة والأبعاد. لتسعيرة دقيقة تواصل معنا.",
      deliveryTimeLabel: "وقت التسليم",
      daysLabel: "أيام",
      ratePerKgLabel: "السعر للكيلو",
      baseFeeLabel: "رسوم الأساس",
      countries: { tr: "تركيا", cn: "الصين", sy: "سوريا" },
      trackStates: {
        received: "تم استلام الشحنة",
        packed: "التغليف والتحضير",
        transit: "في الطريق",
        customs: "تخليص جمركي",
        delivered: "تم التسليم",
      },
      trackNotFound: "لم يتم العثور على شحنة بهذا الرقم. جرب مثال: MK-2025-00123",
      trackFoundTitle: "الشحنة",
      trackEstimate: "التسليم المتوقع",
    },
    about: {
      eyebrow: "من نحن",
      title: "شريك شحن تعتمد عليه",
      body: "نتولّى عنك الجزء الصعب من الاستيراد. نستلم البضاعة من مورّديك، نغلّفها ونخزّنها، ثم نسلّمها لك داخل سوريا في موعدها.",
      pillars: [
        { t: "رؤيتنا", d: "أن نكون الخيار الأول للتجار بين تركيا والصين وسوريا، بمعايير عالمية." },
        { t: "رسالتنا", d: "تبسيط سلسلة الإمداد عبر حلول شحن مرنة، آمنة، وبأسعار تنافسية." },
        { t: "قيمنا", d: "الثقة، الشفافية، السرعة، والمتابعة الدقيقة لكل شحنة." },
      ],
    },
    services: {
      eyebrow: "خدماتنا",
      title: "كل مراحل الشحن عندنا",
      subtitle: "من باب المورّد إلى مستودعك، يتابع فريقنا شحنتك بنفسه في كل مرحلة.",
      items: [
        {
          t: "الشحن من تركيا إلى سوريا",
          d: "خطوط شحن منتظمة من إسطنبول إلى دمشق وحلب بحلول بري وبحري سريع.",
        },
        {
          t: "الشحن من الصين إلى سوريا",
          d: "استيراد مباشر من أهم المدن الصينية مع متابعة كاملة للموردين.",
        },
        {
          t: "تجميع الطلبات والتغليف الآمن",
          d: "دمج شحنات متعددة الموردين وإعادة تغليف احترافية لضمان السلامة.",
        },
        {
          t: "التخزين وإدارة الشحنات",
          d: "مستودعات حديثة في إسطنبول وحلب ودمشق بإدارة ذكية وتقارير دورية.",
        },
        {
          t: "حلول B2B مخصصة للتجار",
          d: "عقود شحن مرنة وأسعار مخصصة للتجار والمشاريع التجارية.",
        },
        {
          t: "تخليص جمركي سريع",
          d: "فريق متخصص بالتخليص الجمركي يختصر الوقت ويقلل التكلفة.",
        },
      ],
    },
    why: {
      eyebrow: "لماذا مسك كارجو",
      title: "خبرة تُقاس بالشحنات لا بالكلام",
      items: [
        { t: "متابعة مستمرة", d: "فريق دعم على مدار الساعة لتحديث حالة شحنتك." },
        { t: "أسعار منافسة", d: "شفافية كاملة في التسعير بدون رسوم مخفية." },
        { t: "أمان وتغليف", d: "إعادة تعبئة احترافية تحمي البضاعة في كل مرحلة." },
        { t: "تغطية واسعة", d: "مكاتب ومستودعات في إسطنبول ودمشق وحلب." },
      ],
    },
    locations: {
      eyebrow: "فروعنا",
      title: "شبكة حاضرة أينما كنت",
      subtitle: "مكاتب ومستودعات في المدن الرئيسية لتسليم أسرع وخدمة أقرب.",
      directions: "احصل على الاتجاهات",
      call: "اتصل",
      list: [
        {
          city: "إسطنبول",
          type: "مكتب ومستودع",
          address: "باشاك شهير - سوق رامي الجديد",
          phone: "+905521627900",
          mapsUrl: "https://maps.app.goo.gl/TJqgUXodsTjh9CmN6",
          mapsQuery: "Başakşehir Rami Market Istanbul",
        },
        {
          city: "دمشق",
          type: "مكتب",
          address: "الزبلطاني - بين كازيه مينا ومركز فحص الايدز",
          phone: "+963945184737",
          mapsUrl: "https://maps.app.goo.gl/zNQwQYEkaWzBV5FE6",
          mapsQuery: "Zablatani Damascus Syria",
        },
        {
          city: "دمشق",
          type: "مستودع",
          address: "أوتوستراد حلب القديم بعد مفرق تل كردي 500 متر",
          phone: "+963994705609",
          mapsUrl: "https://maps.app.goo.gl/JMzULQaM4qicGCSy6",
          mapsQuery: "Old Aleppo Highway Damascus",
        },
        {
          city: "حلب",
          type: "مكتب ومستودع",
          address: "النقارين - المقبرة الحديثة بعدها ب 900 متر ع اليسار قبل المواصلات",
          phone: "+963964355325",
          mapsUrl: "https://maps.app.goo.gl/DQXSddntnqYbRQvi6",
          mapsQuery: "Nuqarin Aleppo Syria",
        },
      ],
    },
    contact: {
      eyebrow: "تواصل معنا",
      title: "نسمعك ونرد بسرعة",
      subtitle: "اكتب لنا ماذا تريد أن تشحن، ونرد عليك بتسعيرة واضحة.",
      nameLabel: "الاسم الكامل",
      emailLabel: "البريد الإلكتروني",
      phoneLabel: "رقم الهاتف",
      originLabel: "بلد المنشأ",
      subjectLabel: "الموضوع",
      messageLabel: "رسالتك",
      submit: "إرسال الرسالة",
      email: "البريد الإلكتروني",
      callUs: "اتصل بنا",
      followUs: "تابعنا",
    },
    footer: {
      tagline: "شريكك الموثوق للشحن من تركيا والصين إلى سوريا.",
      quickLinks: "روابط سريعة",
      contactUs: "تواصل",
      rights: "جميع الحقوق محفوظة",
      madeWith: "صُنع بعناية لأصحاب الطموح",
    },
    common: {
      readMore: "اقرأ المزيد",
      exploreServices: "استكشف الخدمات",
      ourStory: "قصتنا",
      sendMessage: "أرسل رسالة",
    },
    faq: {
      eyebrow: "مركز المساعدة",
      title: "الأسئلة الشائعة",
      subtitle: "كل ما تحتاج معرفته عن الشحن مع مسك كارجو. اعثر على إجابات للأسئلة الشائعة حول التكاليف والجمارك والتتبع والمزيد.",
      searchPlaceholder: "ابحث عن الأسئلة...",
      noResults: "لم يتم العثور على نتائج",
      noResultsDesc: "حاول تعديل استعلام البحث أو تصفح جميع الأسئلة أدناه.",
      clearSearch: "مسح البحث",
      stillQuestions: "لا تزال لديك أسئلة؟",
      stillQuestionsDesc: "لا يمكنك العثور على الإجابة التي تبحث عنها؟ فريقنا هنا لمساعدتك في أي أسئلة حول الشحن الدولي.",
      contactUs: "تواصل معنا",
      callNow: "اتصل الآن",
      categories: {
        costs: "تكاليف الشحن والعروض",
        transit: "أوقات العبور وأنماط الشحن",
        customs: "الجمارك والرسوم والوثائق",
        tracking: "التتبع والرؤية",
        insurance: "التأمين والمطالبات",
        prohibited: "العناصر المحظورة والمقيدة",
        general: "عام / البدء",
      },
      questions: {
        q1: "كيف يتم حساب تكاليف الشحن؟",
        a1: "تعتمد تكاليف الشحن على عدة عوامل: بلد المنشأ والوجهة، وزن وأبعاد البضائع (الوزن القابل للشحن = الوزن الفعلي مقابل الوزن الحجمي، أيهما أكبر)، نمط الشحن (جوي أو بحري أو بري)، وأي رسوم إضافية مثل تعديلات الوقود ورسوم الأمان أو رسوم موسم الذروة. اتصل بنا للحصول على عرض أسعار مفصل مجاني مع تفصيل كامل للتكلفة.",
        q2: "هل هناك أي رسوم مخفية يجب أن أعرفها؟",
        a2: "نحن نؤمن بالشفافية الكاملة في التسعير. بالإضافة إلى سعر الشحن الأساسي، قد تشمل الرسوم الإضافية الشائعة: رسوم الوساطة الجمركية، ورسوم المناولة في الموانئ، ورسوم التوثيق، ورسوم الوجهة. نقدم عرض أسعار مفصل قبل أن تلتزم بأي شحنة.",
        q3: "هل تقدمون خصومات للشاحنين المنتظمين أو بالجملة؟",
        a3: "نعم. نقدم أسعارًا تنافسية للشركات ذات أحجام الشحن المستمرة. تواصل مع فريقنا لمناقشة خطة تسعير مخصصة لاحتياجاتك.",
        q4: "كم من الوقت يستغرق الشحن الدولي؟",
        a4: "تختلف أوقات العبور حسب النمط والمسار. يستغرق الشحن الجوي عادةً من 1 إلى 5 أيام عمل. يستغرق الشحن البحري (FCL/LCL) عمومًا من 10 إلى 35 يومًا حسب الوجهة. يمكن أن يستغرق الشحن البري/الطرقي داخل المناطق المتصلة من 3 إلى 10 أيام. نقدم أوقات عبور تقديرية مع كل عرض أسعار ونبقيك على اطلاع بأي تأخيرات.",
        q5: "ما هي أنماط الشحن التي تقدمونها؟",
        a5: "نقدم الشحن الجوي، والشحن البحري (حاوية كاملة - FCL وحاوية أقل من كاملة - LCL)، والشحن البري (طريق وسكة حديد)، وحلول متعددة الوسائط تجمع بين أنماط متعددة لكفاءة التكلفة. نساعدك في اختيار الخيار الأفضل بناءً على ميزانيتك والجدول الزمني ونوع البضائع.",
        q6: "ما الفرق بين FCL و LCL؟",
        a6: "FCL (حاوية كاملة) يعني أنك تستأجر الحاوية بأكملها - الأفضل للشحنات الكبيرة. LCL (حاوية أقل من كاملة) يعني أن بضائعك تشارك مساحة الحاوية مع شاحنين آخرين - مثالي للشحنات الأصغر. LCL أكثر فعالية من حيث التكلفة للأحجام الصغيرة ولكن عادةً ما يكون لديه أوقات عبور أطول بسبب التوحيد.",
        q7: "هل تتعاملون مع التخليص الجمركي؟",
        a7: "نعم. نقدم خدمات الوساطة الجمركية الكاملة ونتعامل مع وثائق الاستيراد/التصدير نيابة عنك. يبقى فريقنا على اطلاع دائم باللوائح الحالية - بما في ذلك الرسوم الجمركية الثابتة الجديدة للاتحاد الأوروبي بقيمة 3 يورو على الطرود الصغيرة (أقل من 150 يورو) اعتبارًا من 1 يوليو 2026 - لضمان تخليص شحناتك جمركيًا بسلاسة وبدون تأخيرات مكلفة.",
        q8: "ما هي المستندات المطلوبة للشحن الدولي؟",
        a8: "تشمل المستندات القياسية المطلوبة: الفاتورة التجارية، وقائمة التعبئة، وبوليصة الشحن (بحري) أو بوليصة الشحن الجوي (جوي)، وشهادة المنشأ (عند الحاجة)، ونماذج الإقرار الجمركي (CN22/CN23 للشحنات البريدية). اعتمادًا على البضائع والوجهة، قد تكون هناك حاجة إلى تصاريح أو شهادات إضافية. نرشدك خلال كل متطلبات الوثائق.",
        q9: "من المسؤول عن دفع الرسوم الجمركية والضرائب؟",
        a9: "تعتمد المسؤولية على شروط التجارة المتفق عليها (Incoterms) بين المشتري والبائع. تشمل الشروط الشائعة DDP (التسليم مع دفع الرسوم، حيث يغطي المرسل جميع الرسوم) و DAP (التسليم في المكان، حيث يتعامل المستلم مع الرسوم عند الوصول). يمكننا تقديم المشورة بشأن أفضل شروط التجارة لشحنتك.",
        q10: "ما هي قيمة الحد الأدنى وكيف تؤثر على شحنتي؟",
        a10: "عتبة الحد الأدنى هي القيمة التي لا يتم فرض رسوم جمركية عليها. يختلف هذا حسب البلد: الولايات المتحدة لديها عتبة 800 دولار، والمملكة المتحدة لديها 135 جنيهًا إسترلينيًا للرسوم (تطبق ضريبة القيمة المضافة من 1 جنيه إسترليني)، والاتحاد الأوروبي كان لديه عتبة 150 يورو - ومع ذلك، اعتبارًا من 1 يوليو 2026، يطبق الاتحاد الأوروبي الآن رسومًا جمركية ثابتة قدرها 3 يورو لكل بند تعريفي حتى على الطرود التي تقل عن 150 يورو، بسبب إصلاح الجمارك الجديد للاتحاد الأوروبي. نبقيك على اطلاع بجميع اللوائح ذات الصلة.",
        q11: "هل يمكنني تتبع شحنتي في الوقت الفعلي؟",
        a11: "نعم. نقدم تتبع الشحنات في الوقت الفعلي من خلال بوابتنا الإلكترونية. تتلقى تحديثات المعالم في كل مرحلة رئيسية - تأكيد الاستلام، والمغادرة، والوصول إلى ميناء الوجهة، والتخليص الجمركي، والتسليم النهائي. يمكنك أيضًا طلب تحديثات الحالة مباشرة من فريقنا.",
        q12: "ماذا يجب أن أفعل إذا لم يتم تحديث التتبع الخاص بي لعدة أيام؟",
        a12: "توقفات التتبع شائعة أثناء عبور البحر أو الاحتجاز الجمركي. إذا لم يتم تحديث التتبع الخاص بك لأكثر من 72 ساعة ولديك قلق، يرجى الاتصال بفريق الدعم لدينا برقم مرجع الشحنة الخاص بك وسنحقق على الفور.",
        q13: "هل تقدمون تأمين البضائع؟",
        a13: "نعم. نوصي بشدة بتأمين البضائع لجميع الشحنات الدولية. يمكن لفريقنا ترتيب تغطية البضائع لجميع المخاطر التي تحمي بضائعك ضد الخسارة أو الضرر أو السرقة طوال الرحلة بأكملها. مسؤولية الناقل القياسية محدودة وقد لا تغطي قيمة بضائعك بالكامل.",
        q14: "ماذا أفعل إذا وصلت شحنتي تالفة أو مفقودة؟",
        a14: "اتصل بنا على الفور. وثق الضرر بالصور قبل التوقيع على أي إيصال تسليم، واذكر الاستثناءات على وثيقة التسليم. قدم مطالبة رسمية لنا مع مرجع الشحنة والصور والفاتورة التجارية. سيرشدك فريقنا خلال عملية المطالبات ويعمل على حل المشكلة في أسرع وقت ممكن.",
        q15: "ما هي العناصر التي لا يمكن شحنها دوليًا؟",
        a15: "تشمل العناصر المحظورة عادةً: البضائع الخطرة بدون شهادة IATA/IMDG المناسبة، والأسلحة والذخيرة، والسلع المقلدة، والمخدرات، وبعض المواد الكيميائية، والحيوانات الحية (بدون تصاريح خاصة)، والعملة. قد يتم شحن العناصر المقيدة (مثل بطاريات الليثيوم، والمواد القابلة للتلف) ولكنها تتطلب معالجة ووثائق خاصة. اتصل بنا إذا لم تكن متأكدًا من عنصر معين.",
        q16: "هل يمكنكم شحن المواد الخطرة (HazMat)؟",
        a16: "نعم، مع الوثائق والامتثال المناسبين. نتعامل مع شحنات البضائع الخطرة المصنفة التي تتوافق مع لوائح IATA (جوي) و IMDG (بحري). يرجى إبلاغنا بطبيعة بضائعك في وقت الاستفسار حتى نتمكن من ترتيب المعالجة المناسبة.",
        q17: "كيف أحصل على عرض أسعار الشحن؟",
        a17: "يمكنك طلب عرض أسعار مجاني من خلال نموذج الاتصال على موقعنا أو عن طريق التواصل معنا مباشرة عبر البريد الإلكتروني أو الهاتف. يرجى تقديم: المنشأ والوجهة، وأبعاد البضائع والوزن، ونوع البضائع، ونمط الشحن المفضل والجدول الزمني.",
        q18: "هل تقدمون الشحن من الباب إلى الباب؟",
        a18: "نعم. نقدم خدمة كاملة من الباب إلى الباب، والتعامل مع كل خطوة من الاستلام في المنشأ إلى التسليم النهائي في عنوان الوجهة، بما في ذلك التخليص الجمركي. نقدم أيضًا خدمات من الميناء إلى الميناء للعملاء الذين يفضلون إدارة الخدمات اللوجستية الداخلية الخاصة بهم.",
        q19: "هل أنتم وكيل شحن مرخص؟",
        a19: "نعم. مسك كارجو هو وكيل شحن دولي مرخص ومحترف. نعمل بالامتثال الكامل للوائح التجارة الدولية ونعمل مع شبكة عالمية موثوقة من شركاء الشحن والوكلاء.",
      },
    },
  },
  en: {
    dir: "ltr",
    locale: "en",
    brand: "MISK CARGO",
    brandEn: "MISK CARGO",
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      contact: "Contact",
      getQuote: "Get a Quote",
    },
    hero: {
      eyebrow: "International Logistics Solutions",
      title1: "Misk Cargo",
      title2: "Your safe route for trade & shipping",
      subtitle:
        "Reliable shipping from Türkiye and China to Syria, for traders, companies and individuals.",
      ctaQuote: "Get a quote",
      ctaServices: "Explore Our Services",
      statShipments: "Successful Shipments",
      statRoutes: "Active Routes",
      statClients: "Trusted Clients",
      statYears: "Years of Experience",
      trustSafe: "Safe & Insured",
      trustFast: "Fast Transit",
      trustCountries: "Türkiye · China · Syria",
    },
    widget: {
      trackTab: "Track Shipment",
      calcTab: "Shipping Calculator",
      trackLabel: "Waybill Number",
      trackPlaceholder: "e.g., MK-2025-00123",
      trackBtn: "Track Now",
      fromLabel: "Origin Country",
      toLabel: "Destination",
      weightLabel: "Weight (kg)",
      weightPlaceholder: "e.g., 25",
      modeLabel: "Shipping Mode",
      modeAir: "Air",
      modeSea: "Sea",
      modeLand: "Land",
      calcBtn: "Calculate Price",
      resultTitle: "Estimated Quote",
      resultNote: "Estimate only. The final price depends on what you ship and how big it is, so contact us for an exact quote.",
      deliveryTimeLabel: "Delivery Time",
      daysLabel: "days",
      ratePerKgLabel: "Rate per kg",
      baseFeeLabel: "Base Fee",
      countries: { tr: "Türkiye", cn: "China", sy: "Syria" },
      trackStates: {
        received: "Shipment received",
        packed: "Packed & prepared",
        transit: "In transit",
        customs: "Customs clearance",
        delivered: "Delivered",
      },
      trackNotFound: "No shipment found with this number. Try the demo: MK-2025-00123",
      trackFoundTitle: "Shipment",
      trackEstimate: "Expected delivery",
    },
    about: {
      eyebrow: "About Us",
      title: "A shipping partner you can count on",
      body: "We take the hard part of importing off your hands. We collect from your suppliers, pack and store your goods, then deliver them inside Syria on time.",
      pillars: [
        { t: "Our Vision", d: "To be the company traders in Türkiye, China and Syria call first." },
        { t: "Our Mission", d: "Make importing simple, with shipping that is flexible, safe and fairly priced." },
        { t: "Our Values", d: "Honesty, clear prices, speed and close follow-up on every shipment." },
      ],
    },
    services: {
      eyebrow: "Our Services",
      title: "Every step of shipping, handled by us",
      subtitle: "From your supplier's door to your warehouse, our own team follows your shipment at every stage.",
      items: [
        { t: "Shipping from Türkiye to Syria", d: "Regular trips from Istanbul to Damascus and Aleppo, by road or fast sea freight." },
        { t: "Shipping from China to Syria", d: "We import straight from the main Chinese cities and keep in touch with your suppliers." },
        { t: "Consolidation & Safe Packing", d: "Orders from several suppliers become one shipment, repacked so nothing breaks on the way." },
        { t: "Warehousing & Shipment Management", d: "Our own warehouses in Istanbul, Aleppo and Damascus, with regular stock reports." },
        { t: "B2B Solutions for Traders", d: "Flexible contracts and custom prices for merchants who ship often." },
        { t: "Fast Customs Clearance", d: "Our clearance team handles the paperwork, so you save time and money." },
      ],
    },
    why: {
      eyebrow: "Why Misk Cargo",
      title: "Experience measured in shipments, not words",
      items: [
        { t: "Continuous follow-up", d: "Our support team answers day and night and tells you where your goods are." },
        { t: "Competitive pricing", d: "You see the full price up front. No hidden fees." },
        { t: "Safety & packing", d: "We repack fragile goods properly so they arrive in one piece." },
        { t: "Wide coverage", d: "Offices and warehouses in Istanbul, Damascus and Aleppo." },
      ],
    },
    locations: {
      eyebrow: "Our Branches",
      title: "Present wherever you are",
      subtitle: "Offices and warehouses in key cities for faster delivery and closer service.",
      directions: "Get Directions",
      call: "Call",
      list: [
        { 
          city: "Istanbul", 
          type: "Office & Warehouse", 
          address: "Başakşehir, Rami New Market", 
          phone: "+905521627900", 
          mapsUrl: "https://maps.app.goo.gl/TJqgUXodsTjh9CmN6",
          mapsQuery: "Başakşehir Rami Market Istanbul" 
        },
        { 
          city: "Damascus", 
          type: "Office", 
          address: "Zablatani - Between Kaziye Mina and AIDS Testing Center", 
          phone: "+963945184737",
          mapsUrl: "https://maps.app.goo.gl/zNQwQYEkaWzBV5FE6",
          mapsQuery: "Zablatani Damascus Syria" 
        },
        { 
          city: "Damascus", 
          type: "Warehouse", 
          address: "Old Aleppo Highway after Tel Kurdi junction 500m", 
          phone: "+963994705609", 
          mapsUrl: "https://maps.app.goo.gl/JMzULQaM4qicGCSy6",
          mapsQuery: "Old Aleppo Highway Damascus" 
        },
        { 
          city: "Aleppo", 
          type: "Office & Warehouse", 
          address: "Nuqarin - Modern Cemetery 900m after on the left before transport", 
          phone: "+963964355325", 
          mapsUrl: "https://maps.app.goo.gl/DQXSddntnqYbRQvi6",
          mapsQuery: "Nuqarin Aleppo Syria" 
        },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Talk to us. We reply fast.",
      subtitle: "Tell us what you want to ship and we'll send you a clear quote.",
      nameLabel: "Full Name",
      emailLabel: "Email",
      phoneLabel: "Phone Number",
      originLabel: "Origin Country",
      subjectLabel: "Subject",
      messageLabel: "Your Message",
      submit: "Send Message",
      email: "Email",
      callUs: "Call Us",
      followUs: "Follow Us",
    },
    footer: {
      tagline: "Your trusted partner for shipping from Türkiye and China to Syria.",
      quickLinks: "Quick Links",
      contactUs: "Contact",
      rights: "All rights reserved",
      madeWith: "Crafted for ambitious businesses",
    },
    common: {
      readMore: "Read more",
      exploreServices: "Explore Services",
      ourStory: "Our Story",
      sendMessage: "Send Message",
    },
    faq: {
      eyebrow: "Help Center",
      title: "Frequently Asked Questions",
      subtitle: "Everything you need to know about shipping with Misk Cargo. Find answers to common questions about costs, customs, tracking, and more.",
      searchPlaceholder: "Search questions...",
      noResults: "No results found",
      noResultsDesc: "Try adjusting your search query or browse all questions below.",
      clearSearch: "Clear Search",
      stillQuestions: "Still have questions?",
      stillQuestionsDesc: "Can't find the answer you're looking for? Our team is here to help you with any questions about international shipping.",
      contactUs: "Contact Us",
      callNow: "Call Now",
      categories: {
        costs: "Shipping Costs & Quotes",
        transit: "Transit Times & Shipping Modes",
        customs: "Customs, Duties & Documentation",
        tracking: "Tracking & Visibility",
        insurance: "Insurance & Claims",
        prohibited: "Prohibited & Restricted Items",
        general: "General / Getting Started",
      },
      questions: {
        q1: "How are shipping costs calculated?",
        a1: "Shipping costs depend on several factors: the origin and destination countries, the weight and dimensions of your cargo (chargeable weight = actual weight vs. volumetric weight, whichever is greater), the shipping mode (air, sea, or land), and any applicable surcharges such as fuel adjustments, security fees, or peak season charges. Contact us for a free, detailed quote with a full cost breakdown.",
        q2: "Are there any hidden fees I should know about?",
        a2: "We believe in full pricing transparency. Beyond the base freight rate, common additional charges may include: customs brokerage fees, port handling fees, documentation fees, and destination charges. We provide an itemized quote before you commit to any shipment.",
        q3: "Do you offer discounts for regular or bulk shippers?",
        a3: "Yes. We offer competitive rates for businesses with consistent shipping volumes. Reach out to our team to discuss a tailored pricing plan for your needs.",
        q4: "How long does international shipping take?",
        a4: "Transit times vary by mode and route. Air freight typically takes 1–5 business days. Sea freight (FCL/LCL) generally takes 10–35 days depending on the destination. Land/road freight within connected regions can take 3–10 days. We provide estimated transit times with every quote and keep you updated on any delays.",
        q5: "What shipping modes do you offer?",
        a5: "We offer air freight, sea freight (Full Container Load – FCL and Less than Container Load – LCL), land freight (road and rail), and multimodal solutions combining multiple modes for cost efficiency. We help you select the best option based on your budget, timeline, and cargo type.",
        q6: "What is the difference between FCL and LCL?",
        a6: "FCL (Full Container Load) means you rent the entire container, which suits large shipments. LCL (Less than Container Load) means your cargo shares container space with other shippers, which works well for smaller shipments. LCL is more cost-effective for small volumes but typically has longer transit times due to consolidation.",
        q7: "Do you handle customs clearance?",
        a7: "Yes. We offer full customs brokerage services and handle import/export documentation on your behalf. Our team stays up to date with current regulations, including the EU's new fixed €3 customs duty on small parcels (under €150) effective July 1, 2026, to ensure your shipments clear customs smoothly and without costly delays.",
        q8: "What documents are required for international shipping?",
        a8: "Standard required documents include: Commercial Invoice, Packing List, Bill of Lading (sea) or Air Waybill (air), Certificate of Origin (when required), and customs declaration forms (CN22/CN23 for postal shipments). Depending on the goods and destination, additional permits or certificates may be needed. We guide you through every document requirement.",
        q9: "Who is responsible for paying import duties and taxes?",
        a9: "Responsibility depends on the agreed Incoterms (trade terms) between buyer and seller. Common terms include DDP (Delivered Duty Paid, where the sender covers all duties) and DAP (Delivered at Place, where the recipient handles duties on arrival). We can advise on the best Incoterms for your shipment.",
        q10: "What is the de minimis value and how does it affect my shipment?",
        a10: "The de minimis threshold is the value below which no customs duty is charged. This varies by country: the USA has an $800 threshold, the UK has £135 for duties (VAT applies from £1), and the EU had a €150 threshold. However, as of July 1, 2026, the EU now applies a fixed €3 customs duty per tariff heading even on parcels below €150, due to new EU customs reform. We keep you informed of all relevant regulations.",
        q11: "Can I track my shipment in real time?",
        a11: "Yes. We provide real-time shipment tracking through our online portal. You receive milestone updates at every key stage: pickup confirmation, departure, arrival at destination port, customs clearance, and final delivery. You can also request status updates directly from our team.",
        q12: "What should I do if my tracking hasn't updated in several days?",
        a12: "Tracking pauses are common during sea crossings or customs holds. If your tracking has not updated for more than 72 hours and you have a concern, please contact our support team with your shipment reference number and we will investigate immediately.",
        q13: "Do you offer cargo insurance?",
        a13: "Yes. We strongly recommend cargo insurance for all international shipments. Our team can arrange all-risk cargo coverage that protects your goods against loss, damage, or theft throughout the entire journey. Standard carrier liability is limited and may not fully cover your cargo's value.",
        q14: "What do I do if my shipment arrives damaged or is lost?",
        a14: "Contact us immediately. Document the damage with photographs before signing any delivery receipt, and note exceptions on the delivery document. Submit a formal claim to us with your shipment reference, photos, and the commercial invoice. Our team will guide you through the claims process and work to resolve the issue as quickly as possible.",
        q15: "What items cannot be shipped internationally?",
        a15: "Prohibited items typically include: dangerous goods without proper IATA/IMDG certification, weapons and ammunition, counterfeit goods, narcotics, certain chemicals, live animals (without special permits), and currency. Restricted items (e.g., lithium batteries, perishables) may be shipped but require special handling and documentation. Contact us if you are unsure about a specific item.",
        q16: "Can you ship hazardous materials (HazMat)?",
        a16: "Yes, with proper documentation and compliance. We handle classified dangerous goods shipments that comply with IATA (air) and IMDG (sea) regulations. Please inform us of the nature of your goods at the time of inquiry so we can arrange appropriate handling.",
        q17: "How do I get a shipping quote?",
        a17: "You can request a quote through our website's contact form or by reaching out to us directly via email or phone. Please provide: origin and destination, cargo dimensions and weight, type of goods, and your preferred shipping mode and timeline.",
        q18: "Do you offer door-to-door shipping?",
        a18: "Yes. We offer complete door-to-door service, handling every step from pickup at origin to final delivery at the destination address, including customs clearance. We also offer port-to-port services for clients who prefer to manage their own inland logistics.",
        q19: "Are you a licensed freight forwarder?",
        a19: "Yes. Misk Cargo is a licensed and professional international freight forwarder. We operate in full compliance with international trade regulations and work with a trusted global network of shipping partners and agents.",
      },
    },
  },
  tr: {
    dir: "ltr",
    locale: "tr",
    brand: "MISK CARGO",
    brandEn: "MISK CARGO",
    nav: {
      home: "Anasayfa",
      about: "Hakkımızda",
      services: "Hizmetlerimiz",
      contact: "İletişim",
      getQuote: "Teklif Al",
    },
    hero: {
      eyebrow: "Uluslararası Lojistik Çözümleri",
      title1: "Misk Cargo",
      title2: "Ticaret ve kargoda güvenli yolunuz",
      subtitle:
        "Tüccarlar, işletmeler ve bireyler için Türkiye ve Çin'den Suriye'ye güvenilir kargo.",
      ctaQuote: "Teklif al",
      ctaServices: "Hizmetlerimizi Keşfedin",
      statShipments: "Başarılı Gönderi",
      statRoutes: "Aktif Rota",
      statClients: "Güvenilen Müşteri",
      statYears: "Yıllık Deneyim",
      trustSafe: "Güvenli ve Sigortalı",
      trustFast: "Hızlı Transit",
      trustCountries: "Türkiye · Çin · Suriye",
    },
    widget: {
      trackTab: "Kargo Takibi",
      calcTab: "Kargo Hesaplayıcı",
      trackLabel: "Takip Numarası",
      trackPlaceholder: "Örn: MK-2025-00123",
      trackBtn: "Takip Et",
      fromLabel: "Çıkış Ülkesi",
      toLabel: "Varış",
      weightLabel: "Ağırlık (kg)",
      weightPlaceholder: "Örn: 25",
      modeLabel: "Taşıma Türü",
      modeAir: "Havayolu",
      modeSea: "Denizyolu",
      modeLand: "Karayolu",
      calcBtn: "Fiyat Hesapla",
      resultTitle: "Tahmini Fiyat",
      resultNote: "Fiyat tahmidir; kargonun türü ve ebatlarına göre değişir. Kesin teklif için iletişime geçin.",
      deliveryTimeLabel: "Teslimat Süresi",
      daysLabel: "gün",
      ratePerKgLabel: "Kg başına fiyat",
      baseFeeLabel: "Temel Ücret",
      countries: { tr: "Türkiye", cn: "Çin", sy: "Suriye" },
      trackStates: {
        received: "Gönderi alındı",
        packed: "Paketleme tamamlandı",
        transit: "Yolda",
        customs: "Gümrük işlemleri",
        delivered: "Teslim edildi",
      },
      trackNotFound: "Bu numarayla kargo bulunamadı. Demo deneyin: MK-2025-00123",
      trackFoundTitle: "Gönderi",
      trackEstimate: "Tahmini teslimat",
    },
    about: {
      eyebrow: "Hakkımızda",
      title: "Fark yaratan bir lojistik ortağı",
      body: "İthalatın zor kısmını biz üstleniyoruz. Mallarınızı tedarikçilerden alıyor, paketleyip depoluyor ve Suriye içinde zamanında teslim ediyoruz.",
      pillars: [
        { t: "Vizyonumuz", d: "Türkiye, Çin ve Suriye'deki tüccarların ilk aradığı şirket olmak." },
        { t: "Misyonumuz", d: "Esnek, güvenli ve rekabetçi kargo çözümleriyle tedarik zincirini basitleştirmek." },
        { t: "Değerlerimiz", d: "Güven, şeffaflık, hız ve her gönderi için titiz takip." },
      ],
    },
    services: {
      eyebrow: "Hizmetlerimiz",
      title: "Uçtan uca kargo ekosistemi",
      subtitle: "Tedarikçinizin kapısından deponuza kadar gönderinizi her aşamada kendi ekibimiz takip eder.",
      items: [
        { t: "Türkiye'den Suriye'ye Kargo", d: "İstanbul'dan Şam ve Halep'e düzenli kara ve hızlı deniz hatları." },
        { t: "Çin'den Suriye'ye Kargo", d: "Başlıca Çin şehirlerinden tedarikçi takibiyle doğrudan ithalat." },
        { t: "Konsolidasyon ve Güvenli Paketleme", d: "Çoklu tedarikçi birleştirme ve profesyonel yeniden paketleme." },
        { t: "Depolama ve Gönderi Yönetimi", d: "İstanbul, Halep ve Şam'da modern depolar; akıllı raporlama." },
        { t: "Tüccarlar için B2B Çözümleri", d: "Esnek sözleşmeler ve işletmeler için özel fiyatlandırma." },
        { t: "Hızlı Gümrük İşlemleri", d: "Zaman ve maliyeti azaltan uzman gümrük ekibi." },
      ],
    },
    why: {
      eyebrow: "Neden Misk Cargo",
      title: "Sözlerle değil gönderilerle ölçülen deneyim",
      items: [
        { t: "Sürekli takip", d: "7/24 destek ekibi, gönderi durumunuzdan sizi haberdar eder." },
        { t: "Rekabetçi fiyat", d: "Fiyatı baştan görürsünüz. Gizli ücret yok." },
        { t: "Güvenlik ve paketleme", d: "Profesyonel yeniden paketleme her aşamada korur." },
        { t: "Geniş kapsama", d: "İstanbul, Şam ve Halep'te ofis ve depolar." },
      ],
    },
    locations: {
      eyebrow: "Şubelerimiz",
      title: "Neredeyseniz oradayız",
      subtitle: "Daha hızlı teslimat ve daha yakın hizmet için önemli şehirlerde ofis ve depolar.",
      directions: "Yol Tarifi Al",
      call: "Ara",
      list: [
        { 
          city: "İstanbul", 
          type: "Ofis ve Depo", 
          address: "Başakşehir, Rami Yeni Pazar", 
          phone: "+905521627900", 
          mapsUrl: "https://maps.app.goo.gl/TJqgUXodsTjh9CmN6",
          mapsQuery: "Başakşehir Rami Market Istanbul" 
        },
        { 
          city: "Şam", 
          type: "Ofis", 
          address: "Zablatani - Kaziye Mina ile AIDS Test Merkezi arasında", 
          phone: "+963945184737",
          mapsUrl: "https://maps.app.goo.gl/zNQwQYEkaWzBV5FE6",
          mapsQuery: "Zablatani Damascus Syria" 
        },
        { 
          city: "Şam", 
          type: "Depo", 
          address: "Eski Halep Otoyolu Tel Kurdi kavşağından 500m sonra", 
          phone: "+963994705609", 
          mapsUrl: "https://maps.app.goo.gl/JMzULQaM4qicGCSy6",
          mapsQuery: "Old Aleppo Highway Damascus" 
        },
        { 
          city: "Halep", 
          type: "Ofis ve Depo", 
          address: "Nuqarin - Modern Mezarlık 900m sonra solda ulaşımdan önce", 
          phone: "+963964355325", 
          mapsUrl: "https://maps.app.goo.gl/DQXSddntnqYbRQvi6",
          mapsQuery: "Nuqarin Aleppo Syria" 
        },
      ],
    },
    contact: {
      eyebrow: "İletişim",
      title: "Sizi dinler ve hızla yanıtlarız",
      subtitle: "Ücretsiz danışmanlık veya detaylı teklif için bize ulaşın.",
      nameLabel: "Ad Soyad",
      emailLabel: "E-posta",
      phoneLabel: "Telefon",
      originLabel: "Çıkış Ülkesi",
      subjectLabel: "Konu",
      messageLabel: "Mesajınız",
      submit: "Mesaj Gönder",
      email: "E-posta",
      callUs: "Bizi Arayın",
      followUs: "Bizi Takip Edin",
    },
    footer: {
      tagline: "Türkiye ve Çin'den Suriye'ye kargo için güvenilir ortağınız.",
      quickLinks: "Hızlı Bağlantılar",
      contactUs: "İletişim",
      rights: "Tüm hakları saklıdır",
      madeWith: "Hırslı işletmeler için özenle yapıldı",
    },
    common: {
      readMore: "Daha fazla",
      exploreServices: "Hizmetleri Keşfet",
      ourStory: "Hikayemiz",
      sendMessage: "Mesaj Gönder",
    },
    faq: {
      eyebrow: "Yardım Merkezi",
      title: "Sıkça Sorulan Sorular",
      subtitle: "Misk Cargo ile kargo hakkında bilmeniz gereken her şey. Maliyetler, gümrük, takip ve daha fazlası hakkında sık sorulan soruların yanıtlarını bulun.",
      searchPlaceholder: "Soruları ara...",
      noResults: "Sonuç bulunamadı",
      noResultsDesc: "Arama sorgunuzu ayarlamayı deneyin veya aşağıdaki tüm soruları göz atın.",
      clearSearch: "Aramayı Temizle",
      stillQuestions: "Hala sorularınız mı var?",
      stillQuestionsDesc: "Aradığınız cevabı bulamıyor musunuz? Ekibimiz uluslararası kargo hakkındaki tüm sorularınızda size yardımcı olmak için burada.",
      contactUs: "Bize Ulaşın",
      callNow: "Şimdi Ara",
      categories: {
        costs: "Kargo Maliyetleri ve Teklifler",
        transit: "Transit Süreleri ve Kargo Modları",
        customs: "Gümrük, Vergiler ve Belgeler",
        tracking: "Takip ve Görünürlük",
        insurance: "Sigorta ve Talepler",
        prohibited: "Yasaklı ve Kısıtlı Ürünler",
        general: "Genel / Başlangıç",
      },
      questions: {
        q1: "Kargo maliyetleri nasıl hesaplanır?",
        a1: "Kargo maliyetleri birkaç faktöre bağlıdır: menşe ve varış ülkeleri, kargonuzun ağırlığı ve boyutları (ücretlendirilebilir ağırlık = gerçek ağırlık ile hacimsel ağırlık, hangisi daha büyükse), kargo modu (hava, deniz veya kara) ve yakıt ayarlamaları, güvenlik ücretleri veya yoğun sezon ücretleri gibi geçerli ek ücretler. Tam maliyet dökümü ile ücretsiz, ayrıntılı bir teklif için bizimle iletişime geçin.",
        q2: "Bilmem gereken gizli ücretler var mı?",
        a2: "Tam fiyatlandırma şeffaflığına inanıyoruz. Temel navlun ücretinin ötesinde, yaygın ek ücretler şunları içerebilir: gümrük komisyonculuğu ücretleri, liman elleçleme ücretleri, belgelendirme ücretleri ve varış ücretleri. Herhangi bir gönderiye taahhüt etmeden önce ayrıntılı bir teklif sunuyoruz.",
        q3: "Düzenli veya toplu göndericiler için indirim sunuyor musunuz?",
        a3: "Evet. Tutarlı kargo hacimleri olan işletmeler için rekabetçi fiyatlar sunuyoruz. İhtiyaçlarınız için özel bir fiyatlandırma planı görüşmek üzere ekibimizle iletişime geçin.",
        q4: "Uluslararası kargo ne kadar sürer?",
        a4: "Transit süreleri moda ve rotaya göre değişir. Hava kargo genellikle 1-5 iş günü sürer. Deniz kargo (FCL/LCL) genellikle varış yerine bağlı olarak 10-35 gün sürer. Bağlı bölgeler içinde kara/yol kargo 3-10 gün sürebilir. Her teklifle tahmini transit süreleri sağlıyoruz ve herhangi bir gecikme konusunda sizi güncel tutuyoruz.",
        q5: "Hangi kargo modlarını sunuyorsunuz?",
        a5: "Hava kargo, deniz kargo (Tam Konteyner Yükü - FCL ve Tam Konteynerden Az Yük - LCL), kara kargo (yol ve demiryolu) ve maliyet verimliliği için birden fazla modu birleştiren çok modlu çözümler sunuyoruz. Bütçenize, zaman çizelgenize ve kargo türünüze göre en iyi seçeneği seçmenize yardımcı oluyoruz.",
        q6: "FCL ve LCL arasındaki fark nedir?",
        a6: "FCL (Tam Konteyner Yükü) tüm konteyneri kiralamanız anlamına gelir - büyük gönderiler için en iyisi. LCL (Tam Konteynerden Az Yük) kargonuzun diğer göndericilerle konteyner alanını paylaştığı anlamına gelir - daha küçük gönderiler için idealdir. LCL küçük hacimler için daha uygun maliyetlidir ancak konsolidasyon nedeniyle genellikle daha uzun transit sürelerine sahiptir.",
        q7: "Gümrük işlemlerini hallediyor musunuz?",
        a7: "Evet. Tam gümrük komisyonculuğu hizmetleri sunuyoruz ve sizin adınıza ithalat/ihracat belgelerini ele alıyoruz. Ekibimiz, gönderilerinizin sorunsuz ve maliyetli gecikmeler olmadan gümrükten geçmesini sağlamak için - 1 Temmuz 2026'dan itibaren geçerli olan küçük paketlere (150 €'nun altında) AB'nin yeni sabit 3 € gümrük vergisi dahil - güncel düzenlemelerden haberdar kalır.",
        q8: "Uluslararası kargo için hangi belgeler gereklidir?",
        a8: "Standart gerekli belgeler şunları içerir: Ticari Fatura, Paketleme Listesi, Konşimento (deniz) veya Hava Konşimentosu (hava), Menşe Şahadetnamesı (gerektiğinde) ve gümrük beyanname formları (posta gönderileri için CN22/CN23). Mallara ve varış yerine bağlı olarak, ek izinler veya sertifikalar gerekebilir. Her belge gerekliliği konusunda size rehberlik ediyoruz.",
        q9: "İthalat vergileri ve vergilerini ödemekten kim sorumludur?",
        a9: "Sorumluluk, alıcı ve satıcı arasında üzerinde anlaşılan Incoterms'e (ticaret koşulları) bağlıdır. Yaygın terimler DDP'yi (Teslim Edilen Vergi Ödenmiş, gönderenin tüm vergileri karşıladığı) ve DAP'yi (Yerde Teslim Edilen, alıcının varışta vergileri ele aldığı) içerir. Gönderiniz için en iyi Incoterms konusunda tavsiyede bulunabiliriz.",
        q10: "De minimis değeri nedir ve gönderimi nasıl etkiler?",
        a10: "De minimis eşiği, altında gümrük vergisi alınmayan değerdir. Bu ülkeye göre değişir: ABD'de 800 $ eşiği vardır, Birleşik Krallık'ta vergiler için 135 £ vardır (KDV 1 £'den itibaren uygulanır) ve AB'de 150 € eşiği vardı - ancak 1 Temmuz 2026 itibariyle, AB artık yeni AB gümrük reformu nedeniyle 150 €'nun altındaki paketlerde bile tarife başlığı başına sabit 3 € gümrük vergisi uygulamaktadır. Tüm ilgili düzenlemeler hakkında sizi bilgilendiriyoruz.",
        q11: "Gönderimi gerçek zamanlı olarak takip edebilir miyim?",
        a11: "Evet. Çevrimiçi portalımız aracılığıyla gerçek zamanlı gönderi takibi sağlıyoruz. Her önemli aşamada kilometre taşı güncellemeleri alırsınız - alım onayı, kalkış, varış limanına varış, gümrük işlemleri ve nihai teslimat. Ayrıca ekibimizden doğrudan durum güncellemeleri talep edebilirsiniz.",
        q12: "Takibim birkaç gündür güncellenmemişse ne yapmalıyım?",
        a12: "Takip duraklamaları deniz geçişleri veya gümrük bekletmeleri sırasında yaygındır. Takibiniz 72 saatten fazla güncellenmemişse ve endişeniz varsa, lütfen gönderi referans numaranızla destek ekibimizle iletişime geçin ve hemen araştıracağız.",
        q13: "Kargo sigortası sunuyor musunuz?",
        a13: "Evet. Tüm uluslararası gönderiler için kargo sigortasını şiddetle tavsiye ediyoruz. Ekibimiz, tüm yolculuk boyunca mallarınızı kayıp, hasar veya hırsızlığa karşı koruyan tüm riskli kargo kapsamını düzenleyebilir. Standart taşıyıcı sorumluluğu sınırlıdır ve kargonuzun değerini tam olarak karşılamayabilir.",
        q14: "Gönderim hasarlı gelirse veya kaybolursa ne yapmalıyım?",
        a14: "Hemen bizimle iletişime geçin. Herhangi bir teslimat makbuzunu imzalamadan önce hasarı fotoğraflarla belgeleyin ve teslimat belgesinde istisnaları not edin. Gönderi referansınız, fotoğraflar ve ticari fatura ile bize resmi bir talep gönderin. Ekibimiz talep sürecinde size rehberlik edecek ve sorunu mümkün olan en kısa sürede çözmek için çalışacaktır.",
        q15: "Hangi ürünler uluslararası olarak gönderilemez?",
        a15: "Yasaklı ürünler genellikle şunları içerir: uygun IATA/IMDG sertifikası olmayan tehlikeli maddeler, silahlar ve mühimmat, sahte mallar, uyuşturucular, belirli kimyasallar, canlı hayvanlar (özel izinler olmadan) ve para birimi. Kısıtlı ürünler (örneğin, lityum piller, bozulabilir ürünler) gönderilebilir ancak özel elleçleme ve belgelendirme gerektirir. Belirli bir ürün hakkında emin değilseniz bizimle iletişime geçin.",
        q16: "Tehlikeli maddeleri (HazMat) gönderebilir misiniz?",
        a16: "Evet, uygun belgelendirme ve uyumlulukla. IATA (hava) ve IMDG (deniz) düzenlemelerine uygun sınıflandırılmış tehlikeli mal gönderilerini ele alıyoruz. Lütfen uygun elleçlemeyi düzenleyebilmemiz için sorgulama sırasında mallarınızın doğasını bize bildirin.",
        q17: "Kargo teklifi nasıl alabilirim?",
        a17: "Web sitemizin iletişim formu aracılığıyla veya doğrudan e-posta veya telefon yoluyla bizimle iletişime geçerek ücretsiz bir teklif talep edebilirsiniz. Lütfen şunları sağlayın: menşe ve varış, kargo boyutları ve ağırlığı, mal türü ve tercih ettiğiniz kargo modu ve zaman çizelgesi.",
        q18: "Kapıdan kapıya kargo sunuyor musunuz?",
        a18: "Evet. Menşedeki alımdan varış adresindeki nihai teslimata kadar her adımı ele alan, gümrük işlemleri dahil olmak üzere eksiksiz kapıdan kapıya hizmet sunuyoruz. Kendi iç lojistiklerini yönetmeyi tercih eden müşteriler için limandan limana hizmetler de sunuyoruz.",
        q19: "Lisanslı bir navlun ileticisi misiniz?",
        a19: "Evet. Misk Cargo lisanslı ve profesyonel bir uluslararası navlun ileticisidir. Uluslararası ticaret düzenlemelerine tam uyum içinde faaliyet gösteriyoruz ve güvenilir bir küresel kargo ortakları ve acenteler ağıyla çalışıyoruz.",
      },
    },
  },
  "zh-CN": {
    dir: "ltr",
    locale: "zh-CN",
    brand: "MISK CARGO",
    brandEn: "MISK CARGO",
    nav: {
      home: "首页",
      about: "关于我们",
      services: "服务项目",
      contact: "联系我们",
      getQuote: "获取报价",
    },
    hero: {
      eyebrow: "国际物流解决方案",
      title1: "Misk Cargo",
      title2: "您的贸易与货运安全之路",
      subtitle:
        "为贸易商、企业和个人提供从土耳其和中国到叙利亚的可靠货运。",
      ctaQuote: "获取报价",
      ctaServices: "探索我们的服务",
      statShipments: "成功运输",
      statRoutes: "活跃路线",
      statClients: "信赖客户",
      statYears: "年经验",
      trustSafe: "安全可靠",
      trustFast: "快速运输",
      trustCountries: "土耳其 · 中国 · 叙利亚",
    },
    widget: {
      trackTab: "货物追踪",
      calcTab: "运费计算器",
      trackLabel: "运单号码",
      trackPlaceholder: "例如：MK-2025-00123",
      trackBtn: "立即追踪",
      fromLabel: "起运国",
      toLabel: "目的地",
      weightLabel: "重量（公斤）",
      weightPlaceholder: "例如：25",
      modeLabel: "运输方式",
      modeAir: "空运",
      modeSea: "海运",
      modeLand: "陆运",
      calcBtn: "计算价格",
      resultTitle: "预估报价",
      resultNote: "仅供参考。最终价格取决于货物类型和尺寸，请联系我们获取准确报价。",
      deliveryTimeLabel: "交货时间",
      daysLabel: "天",
      ratePerKgLabel: "每公斤费率",
      baseFeeLabel: "基础费用",
      countries: { tr: "土耳其", cn: "中国", sy: "叙利亚" },
      trackStates: {
        received: "已收货",
        packed: "已打包准备",
        transit: "运输中",
        customs: "清关中",
        delivered: "已送达",
      },
      trackNotFound: "未找到此单号的货物。试试示例：MK-2025-00123",
      trackFoundTitle: "货物",
      trackEstimate: "预计送达",
    },
    about: {
      eyebrow: "关于我们",
      title: "与众不同的物流合作伙伴",
      body: "进口中最麻烦的部分交给我们。我们从供应商处提货，打包、仓储，再准时送到叙利亚境内。",
      pillars: [
        { t: "我们的愿景", d: "成为土耳其、中国和叙利亚贸易商的首选。" },
        { t: "我们的使命", d: "通过灵活、安全和具有竞争力的货运解决方案简化供应链。" },
        { t: "我们的价值观", d: "信任、透明、速度以及对每批货物的细致追踪。" },
      ],
    },
    services: {
      eyebrow: "我们的服务",
      title: "端到端货运生态系统",
      subtitle: "从供应商门口到您的仓库，我们自己的团队全程跟进您的货物。",
      items: [
        { t: "从土耳其到叙利亚的货运", d: "从伊斯坦布尔到大马士革和阿勒颇的定期线路，可选陆运或快速海运。" },
        { t: "从中国到叙利亚的货运", d: "从中国主要城市直接进口，全程供应商跟进。" },
        { t: "拼箱与安全包装", d: "多供应商拼箱和专业重新包装，确保最大安全性。" },
        { t: "仓储与货运管理", d: "在伊斯坦布尔、阿勒颇和大马士革设有现代化仓库，配备智能报告系统。" },
        { t: "面向贸易商的B2B解决方案", d: "为商家和企业提供灵活合同和定制价格。" },
        { t: "快速清关", d: "专业清关团队，节省时间并降低成本。" },
      ],
    },
    why: {
      eyebrow: "为什么选择Misk Cargo",
      title: "用货运量而非言语衡量的经验",
      items: [
        { t: "持续跟进", d: "全天候支持团队随时更新您的货物状态。" },
        { t: "竞争性价格", d: "价格事先说清楚，没有任何隐藏费用。" },
        { t: "安全与包装", d: "专业重新包装在每个阶段保护您的货物。" },
        { t: "广泛覆盖", d: "在伊斯坦布尔、大马士革和阿勒颇设有办事处和仓库。" },
      ],
    },
    locations: {
      eyebrow: "我们的分支机构",
      title: "无论您在哪里，我们都在",
      subtitle: "在主要城市设有办事处和仓库，提供更快的配送和更近的服务。",
      directions: "获取路线",
      call: "致电",
      list: [
        { 
          city: "伊斯坦布尔", 
          type: "办事处与仓库", 
          address: "巴沙克谢希尔，拉米新市场", 
          phone: "+905521627900", 
          mapsUrl: "https://maps.app.goo.gl/TJqgUXodsTjh9CmN6",
          mapsQuery: "Başakşehir Rami Market Istanbul" 
        },
        { 
          city: "大马士革", 
          type: "办事处", 
          address: "扎布拉塔尼 - 位于Kaziye Mina和艾滋病检测中心之间", 
          phone: "+963945184737",
          mapsUrl: "https://maps.app.goo.gl/zNQwQYEkaWzBV5FE6",
          mapsQuery: "Zablatani Damascus Syria" 
        },
        { 
          city: "大马士革", 
          type: "仓库", 
          address: "老阿勒颇高速公路，Tel Kurdi路口后500米", 
          phone: "+963994705609", 
          mapsUrl: "https://maps.app.goo.gl/JMzULQaM4qicGCSy6",
          mapsQuery: "Old Aleppo Highway Damascus" 
        },
        { 
          city: "阿勒颇", 
          type: "办事处与仓库", 
          address: "努卡林 - 现代公墓后900米，左侧，交通站前", 
          phone: "+963964355325", 
          mapsUrl: "https://maps.app.goo.gl/DQXSddntnqYbRQvi6",
          mapsQuery: "Nuqarin Aleppo Syria" 
        },
      ],
    },
    contact: {
      eyebrow: "联系我们",
      title: "认真倾听，快速回复",
      subtitle: "联系我们获取免费咨询或详细报价。",
      nameLabel: "全名",
      emailLabel: "电子邮件",
      phoneLabel: "电话号码",
      originLabel: "起运国",
      subjectLabel: "主题",
      messageLabel: "您的留言",
      submit: "发送消息",
      email: "电子邮件",
      callUs: "致电我们",
      followUs: "关注我们",
    },
    footer: {
      tagline: "您从土耳其和中国到叙利亚货运的可靠合作伙伴。",
      quickLinks: "快速链接",
      contactUs: "联系",
      rights: "版权所有",
      madeWith: "为雄心勃勃的企业精心打造",
    },
    common: {
      readMore: "阅读更多",
      exploreServices: "探索服务",
      ourStory: "我们的故事",
      sendMessage: "发送消息",
    },
    faq: {
      eyebrow: "帮助中心",
      title: "常见问题",
      subtitle: "关于Misk Cargo货运您需要了解的一切。查找有关费用、海关、追踪等常见问题的答案。",
      searchPlaceholder: "搜索问题...",
      noResults: "未找到结果",
      noResultsDesc: "尝试调整您的搜索查询或浏览下面的所有问题。",
      clearSearch: "清除搜索",
      stillQuestions: "还有问题吗？",
      stillQuestionsDesc: "找不到您要找的答案？我们的团队随时为您解答有关国际货运的任何问题。",
      contactUs: "联系我们",
      callNow: "立即致电",
      categories: {
        costs: "运费和报价",
        transit: "运输时间和运输方式",
        customs: "海关、关税和文件",
        tracking: "追踪和可见性",
        insurance: "保险和索赔",
        prohibited: "禁运和限制物品",
        general: "一般/入门",
      },
      questions: {
        q1: "运费如何计算？",
        a1: "运费取决于几个因素：起运国和目的地国、货物的重量和尺寸（计费重量=实际重量与体积重量中较大者）、运输方式（空运、海运或陆运）以及任何适用的附加费，如燃油调整费、安全费或旺季费用。请联系我们获取免费的详细报价和完整的费用明细。",
        q2: "有我应该知道的隐藏费用吗？",
        a2: "我们相信完全的价格透明度。除了基本运费外，常见的额外费用可能包括：报关代理费、港口装卸费、文件费和目的地费用。在您承诺任何货运之前，我们会提供详细的报价。",
        q3: "您为定期或批量托运人提供折扣吗？",
        a3: "是的。我们为具有持续货运量的企业提供有竞争力的价格。请联系我们的团队讨论适合您需求的定制定价计划。",
        q4: "国际货运需要多长时间？",
        a4: "运输时间因方式和路线而异。空运通常需要1-5个工作日。海运（整箱/拼箱）通常需要10-35天，具体取决于目的地。连接地区内的陆运/公路运输可能需要3-10天。我们为每个报价提供预计的运输时间，并随时通知您任何延误。",
        q5: "您提供哪些运输方式？",
        a5: "我们提供空运、海运（整箱货运-FCL和拼箱货运-LCL）、陆运（公路和铁路）以及结合多种方式以提高成本效益的多式联运解决方案。我们帮助您根据预算、时间表和货物类型选择最佳选项。",
        q6: "FCL和LCL有什么区别？",
        a6: "FCL（整箱货运）意味着您租用整个集装箱，最适合大批量货运。LCL（拼箱货运）意味着您的货物与其他托运人共享集装箱空间，非常适合较小的货运。LCL对于小批量更具成本效益，但由于拼箱，通常运输时间更长。",
        q7: "您处理清关吗？",
        a7: "是的。我们提供全面的报关代理服务，并代表您处理进出口文件。我们的团队随时了解当前法规，包括自2026年7月1日起生效的欧盟对小包裹（低于150欧元）的新固定3欧元关税，以确保您的货物顺利清关，没有昂贵的延误。",
        q8: "国际货运需要哪些文件？",
        a8: "标准所需文件包括：商业发票、装箱单、提单（海运）或空运提单（空运）、原产地证明（需要时）和海关申报表（邮政货运的CN22/CN23）。根据货物和目的地，可能需要额外的许可证或证书。我们会指导您完成每个文件要求。",
        q9: "谁负责支付进口关税和税款？",
        a9: "责任取决于买方和卖方之间商定的国际贸易术语（Incoterms）。常见术语包括DDP（完税后交货，发件人承担所有关税）和DAP（目的地交货，收件人在到达时处理关税）。我们可以就您的货运的最佳国际贸易术语提供建议。",
        q10: "最低限额是什么，它如何影响我的货运？",
        a10: "最低限额是不收取关税的价值。这因国家而异：美国的门槛为800美元，英国的关税门槛为135英镑（增值税从1英镑起适用），欧盟的门槛为150欧元。然而，自2026年7月1日起，由于新的欧盟海关改革，欧盟现在对低于150欧元的包裹也按每个税号征收固定的3欧元关税。我们会随时通知您所有相关法规。",
        q11: "我可以实时追踪我的货物吗？",
        a11: "是的。我们通过在线门户提供实时货物追踪。您会在每个关键阶段收到里程碑更新：取货确认、出发、到达目的港、清关和最终交付。您也可以直接向我们的团队请求状态更新。",
        q12: "如果我的追踪几天没有更新，我该怎么办？",
        a12: "在海上航行或海关扣留期间，追踪暂停是常见的。如果您的追踪超过72小时未更新并且您有疑虑，请联系我们的支持团队并提供您的货运参考号，我们将立即调查。",
        q13: "您提供货物保险吗？",
        a13: "是的。我们强烈建议为所有国际货运购买货物保险。我们的团队可以安排全险货物保险，在整个旅程中保护您的货物免受损失、损坏或盗窃。标准承运人责任有限，可能无法完全覆盖您的货物价值。",
        q14: "如果我的货物到达时损坏或丢失，我该怎么办？",
        a14: "请立即联系我们。在签署任何交付收据之前用照片记录损坏，并在交付文件上注明例外情况。向我们提交正式索赔，包括您的货运参考、照片和商业发票。我们的团队将指导您完成索赔流程，并尽快解决问题。",
        q15: "哪些物品不能国际运输？",
        a15: "禁运物品通常包括：没有适当IATA/IMDG认证的危险品、武器和弹药、假冒商品、毒品、某些化学品、活体动物（没有特殊许可证）和货币。限制物品（例如锂电池、易腐品）可以运输，但需要特殊处理和文件。如果您不确定特定物品，请联系我们。",
        q16: "您能运输危险材料（HazMat）吗？",
        a16: "是的，需要适当的文件和合规性。我们处理符合IATA（空运）和IMDG（海运）法规的分类危险品货运。请在询问时告知我们您的货物性质，以便我们安排适当的处理。",
        q17: "我如何获得货运报价？",
        a17: "您可以通过我们网站的联系表格或直接通过电子邮件或电话联系我们来请求报价。请提供：起运地和目的地、货物尺寸和重量、货物类型以及您首选的运输方式和时间表。",
        q18: "您提供门到门货运吗？",
        a18: "是的。我们提供完整的门到门服务，处理从起运地取货到目的地地址最终交付的每一步，包括清关。我们还为希望管理自己内陆物流的客户提供港到港服务。",
        q19: "您是持牌货运代理吗？",
        a19: "是的。Misk Cargo是一家持牌和专业的国际货运代理。我们完全遵守国际贸易法规，并与值得信赖的全球货运合作伙伴和代理网络合作。",
      },
    },
  },
};

// Shipping calculator rates (per kg, USD) — based on 2024-2025 market research
// Rates include: pickup, packing, transit, customs clearance, and delivery to Syria
// Sources: Industry averages for Turkey-Syria and China-Syria routes
export const CALC_RATES = {
  tr: { 
    land: 1.2,  // Land freight: $1.2/kg (5-7 days) - Most economical for Turkey-Syria
    sea: 0.85,  // Sea freight: $0.85/kg (15-25 days) - For bulk shipments
    air: 4.5,   // Air freight: $4.5/kg (2-4 days) - Fastest option
    base: 30    // Base handling fee
  },
  cn: { 
    land: 2.8,  // Land freight: $2.8/kg (25-35 days) - Via Turkey
    sea: 1.5,   // Sea freight: $1.5/kg (30-45 days) - Most common for China
    air: 6.5,   // Air freight: $6.5/kg (5-10 days) - Express option
    base: 50    // Base handling fee (higher due to distance)
  },
};

// Delivery time estimates (in days)
export const DELIVERY_TIMES = {
  tr: {
    land: "5-7",   // Turkey to Syria by land
    sea: "15-25",  // Turkey to Syria by sea
    air: "2-4"     // Turkey to Syria by air
  },
  cn: {
    land: "25-35", // China to Syria via land (through Turkey)
    sea: "30-45",  // China to Syria by sea
    air: "5-10"    // China to Syria by air
  }
};

// Demo tracking data
export const DEMO_TRACKING = {
  "MK-2025-00123": {
    origin: "tr",
    destination: "sy",
    currentStep: 3, // 0..4
    estimated: "2025-12-18",
    weight: 47,
    mode: "land",
  },
  "MK-2025-00456": {
    origin: "cn",
    destination: "sy",
    currentStep: 2,
    estimated: "2026-01-02",
    weight: 120,
    mode: "sea",
  },
};
